// @flow
import React, { type ElementRef } from 'react';
import i18n from 'app/common/lib/i18n';
import InterestMasonry from 'app/common/react/components/growth/activation/InterestMasonry/InterestMasonry';
import NuxInterest from 'app/common/react/components/growth/activation/NuxInterest/NuxInterest';
import storage from 'app/common/lib/Storage';
import { Experiment } from 'app/common/react/components/experiments';
import { getInterestRecSource } from 'app/common/react/components/growth/activation/NuxUtils/NuxUtils';
import { type InterestObj } from 'app/common/react/components/growth/activation/NuxConst/NuxConst';
import { Box, Text } from 'gestalt';

type OwnProps = {|
  gridContainerRef: ElementRef<any>,
  handleInterestClickFn: (InterestObj) => () => void,
  interests: Array<InterestObj>,
  showTableOfContents?: boolean,
  interestFlipMessages: { [key: string]: string },
  interestsToFlip: Set<string>,
  isRenux: boolean,
|};

type InterestProps = {|
  itemIdx: number,
  data: InterestObj,
|};

const NuxPickerInterests = (props: OwnProps) => {
  const {
    interests,
    handleInterestClickFn,
    interestFlipMessages,
    interestsToFlip,
    isRenux,
  } = props;

  // This should really be in its own file, but Masonry only passes itemIdx and data.
  // Therefore, we must give it access to the props of this file.
  // Ask @kdavison (Growth - NUX) for more context.
  const Interest = ({ itemIdx: index, data: interest }: InterestProps) => {
    const interestProps = {
      clickHandler: handleInterestClickFn(interest),
      interest,
      key: interest.id,
      isRenux,
      isSelected: interest.is_followed,
      flipText: interestFlipMessages[interest.id] || '',
      shouldFlip: interestsToFlip.has(interest.id),
      size: 'lg_136',
    };

    if (interests.length > 0) {
      storage.localStorage.setItem(
        PCONST.LOCALSTORAGE_SIGNUP_INTERESTS_PICKER_START_TIME,
        Date.now(),
      );
    }

    return <NuxInterest {...interestProps} />;
  };

  const pickerIncludesSeoTopics =
    interests.length > 5 && getInterestRecSource(interests[0]) === 'viewed_recs';

  return (
    <Experiment name="web_nux_picker_pfy_section" isEligible={!isRenux && pickerIncludesSeoTopics}>
      {({ anyEnabled }) => {
        const first5 = interests.slice(0, 5);
        const remaining = interests.slice(5);

        return anyEnabled ? (
          <React.Fragment>
            <Box paddingX={8} marginTop={1} marginBottom={1} wrap>
              <Text size="md" weight="bold">
                {i18n._(
                  'Recommended for you',
                  'Title above a personalized list of topics for user to follow',
                )}
              </Text>
            </Box>
            <InterestMasonry {...props} interests={first5} InterestComponentToRender={Interest} />
            <Box paddingX={8} marginTop={7} marginBottom={1} wrap>
              <Text size="md" weight="bold">
                {i18n._(
                  'More topics',
                  'Title above list of topics user can follow. Previous section said "Recommended for you"',
                )}
              </Text>
            </Box>
            <InterestMasonry
              {...props}
              interests={remaining}
              InterestComponentToRender={Interest}
            />
          </React.Fragment>
        ) : (
          <InterestMasonry {...props} InterestComponentToRender={Interest} />
        );
      }}
    </Experiment>
  );
};

export default NuxPickerInterests;
